import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { galleryItems } from '../mock';

const Gallery = () => {
  const { theme } = useTheme();
  const [active, setActive] = useState(null);

  return (
    <div style={{ background: theme.body, color: theme.bodyText }} className="transition-colors duration-500">
      <section className="py-20 px-6 lg:px-10" style={{ background: theme.sectionAlt }}>
        <div className="max-w-5xl mx-auto text-center">
          <div className="text-xs tracking-[0.3em] mb-3" style={{ color: theme.brand }}>— DARSHANA —</div>
          <h1 className="font-serif text-5xl md:text-6xl font-semibold mb-4" style={{ color: theme.brand }}>Gallery</h1>
          <p style={{ color: theme.muted }}>Glimpses of our work, our heritage, and our living tradition.</p>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {galleryItems.map((g, i) => (
            <button
              key={i}
              onClick={() => setActive(g)}
              className="relative group overflow-hidden rounded-xl aspect-square"
              style={{ border: `1px solid ${theme.cardBorder}` }}
            >
              <img src={g.src} alt={g.caption} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 flex items-end p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.7), rgba(0,0,0,0))' }}>
                <span className="text-white text-sm text-left font-serif">{g.caption}</span>
              </div>
            </button>
          ))}
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-6"
          style={{ background: 'rgba(0,0,0,0.85)' }}
          onClick={() => setActive(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 rounded-full flex items-center justify-center"
            style={{ background: theme.accent, color: theme.accentText }}
            onClick={() => setActive(null)}
          >
            <X size={20} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.src} alt={active.caption} className="w-full h-auto rounded-xl" />
            <p className="text-center mt-4 font-serif text-lg" style={{ color: theme.brand }}>{active.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
